import * as actions from './actions'
import * as mutations from './mutations'
import editBuffer from './editBuffer'
import * as getters from './getters'

const state = {
  ui: {
    selection: {
      company: null
    },
    editing: false
  },
  data: {
    companies: [] // usually for current orgunit
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
  modules: {
    editBuffer
  }
}
